import React from 'react'
import PropTypes from 'prop-types'
import {Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'

const CardTitle = () => {
    const styles = useMultiStyleConfig('GiftCertificate')
    const intl = useIntl()
    return (
        <Text {...styles.rightBox.cardTitle}>
            {intl.formatMessage({
                id: 'eGiftcard.product.title',
                defaultMessage: 'eGift Card'
            })}
        </Text>
    )
}

CardTitle.propTypes = {
    selectedId: PropTypes.string,
    eGiftCardsJson: PropTypes.object
}

export default CardTitle
